<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter">
            <div
              class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
            >
              <img
                src="@/assets/images/login-bg.jpg"
                alt="register"
                class="mx-auto"
              />
            </div>
            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
            >
              <div class="px-8 pt-8 register-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Account erstellen</h4>
                  <p class="mb-2">Für schnellere Bestellungen</p>
                </div>

                <div class="clearfix pb-4">
                  <vs-input
                    label-placeholder="Vor- und Nachname"
                    name="name"
                    v-model="name"
                    class="w-full"
                  />
                  <span class="text-danger text-sm"></span>

                  <vs-input
                    name="email"
                    type="email"
                    label-placeholder="E-mail"
                    v-model="email"
                    class="w-full mt-6"
                  />
                  <span class="text-danger text-sm"></span>

                  <vs-input
                    ref="password"
                    type="password"
                    name="password"
                    label-placeholder="Passwort"
                    v-model="password"
                    class="w-full mt-6"
                  />
                  <span class="text-danger text-sm"></span>

                  <vs-input
                    type="password"
                    data-vv-as="password"
                    name="confirm_password"
                    label-placeholder="Passwort wiederholen"
                    v-model="confirm_password"
                    class="w-full mt-6"
                  />
                  <span class="text-danger text-sm"></span>

                  <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6"
                    >Datenschutzbedingungen akzeptieren
                  </vs-checkbox>
                  <vs-button type="border" to="login" class="mt-6"
                    >Login</vs-button
                  >
                  <vs-button
                    class="float-right mt-6"
                    @click="onRegister"
                    :disabled="!validateForm"
                    >Registrieren</vs-button
                  >
                   <div class="flex flex-wrap justify-start my-5"> 
                       <router-link to="/">Überspringen und als Gast bestellen</router-link> 
                  </div>
                  <div class="flex flex-wrap justify-start my-5 cursor-pointer" @click="showPopupPrivacyStatement = !showPopupPrivacyStatement"> 
                      Datenschutzbedingungen lesen
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <vs-popup fullscreen class="" title="Datenschutzerklärung" :active.sync="showPopupPrivacyStatement">
      <privacy-statement></privacy-statement>
    </vs-popup>
  </div>
</template>


<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      name: "",
      email: "",
      password: "",
      confirm_password: "",
      isTermsConditionAccepted: false,
      errors: null,

      showPopupPrivacyStatement: false
    };
  },
  computed: {
    validateForm() {
      return (
        !this.errors &&
        this.name !== "" &&
        this.email !== "" &&
        this.password !== "" &&
        this.confirm_password !== "" &&
        this.isTermsConditionAccepted === true
      );
    },
  },
  methods: {
    ...mapActions({
      register: "auth/register",
    }),
    route(route) {
      this.$router.replace({
              name: route,
            })
    },
    onRegister() {
      if (this.password !== this.confirm_password) {
          this.$vs.notify({
              title: "Fehler",
              text: "Passwörter stimmen nicht überein",
              color: "danger",
              position: "bottom-center",
              icon: "error",
            });
      } else {
        this.register({
          name: this.name,
          email: this.email,
          password: this.password,
        })
          .then(() => {       
            this.$vs.dialog({
              color:"success",
              title: `Herzlich willkommen, ${this.name}!`,
              text: 'Gib deine Adresse an, damit du diese nicht bei jeder Bestellung neu eingeben musst!',
              accept: this.route("user-settings"),
              acceptText: "Verstanden",
          });
          })
          .catch((error) => {
            console.log(error);
            this.$vs.notify({
              title: "Fehler",
              text: "Fehler bei deiner Registrierung",
              color: "danger",
              position: "bottom-center",
              icon: "error",
            });
          });
      }
    },
  },
};
</script>


